<template>
  <div>
    <Table
      :tableHeaders="tableHeaders"
      :tableData="tableData"
      :initialValues="initialValues"
      :tableFooter="false"
    >
      <template #tableRow="{ request, index }">
        <tr class="font-sans text-xs border-b border-brand-gray-300 w-full">
          <slot name="tableRow" :request="request">
            <td
              class="px-6 py-2 text-gray-700 text-sm font-normal border-r border-brand-gray-300 text-wrap"
            >
              {{ formateRowValue(request, index) }}
            </td>
          </slot>

          <td class="px-6 py-2">
            <div class="flex items-center justify-center"></div>
          </td>
        </tr>
      </template>
    </Table>
  </div>
</template>
<script setup>
import Table from '@/components/Table/index.vue'
import lodashGet from 'lodash/get'

const props = defineProps({
  tableData: {
    type: Array,
    default: () => []
  },
  tableKeyList: {
    type: Array,
    default: () => []
  },
  initialValues: {
    type: Object,
    default: () => {
      return {
        pageSize: 10,
        currentPage: 1
      }
    }
  },
  pageLength: {
    type: Number,
    required: true
  }
})

const formateRowValue = (request, index) => {
  const currentKey = props.tableKeyList[index]
  return lodashGet(request, currentKey)
}
</script>
